import { render } from "./FormTemplate.vue?vue&type=template&id=5fb2f964&scoped=true"
import script from "./FormTemplate.vue?vue&type=script&lang=js"
export * from "./FormTemplate.vue?vue&type=script&lang=js"

import "./FormTemplate.vue?vue&type=style&index=0&id=5fb2f964&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb2f964"]])

export default __exports__